/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { useTranslations } from 'next-intl'
import * as React from 'react'

import { useCarousel } from '@/components/e-commerce/kits/kit-gallery-carousel/Carousel'
import { cn } from '@/utils/css'

type CarouselThumbnailProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  index: number
}

const CarouselThumbnail = React.forwardRef<HTMLButtonElement, CarouselThumbnailProps>(
  ({ index, className, children, ...props }, ref) => {
    const t = useTranslations('CarouselThumbnail')
    const { selectedIndex, thumbnailOnClick } = useCarousel()

    return (
      <button
        type={'button'}
        ref={ref}
        aria-label={t('selectImage', { index: index + 1 })}
        className={cn(
          'relative cursor-pointer rounded-2xl overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2',
          index === selectedIndex && 'border-2 border-blue-500',
          index !== selectedIndex && 'border border-grey-50/20',
          className,
        )}
        onClick={() => thumbnailOnClick(index)}
        {...props}
      >
        {children}
      </button>
    )
  },
)
CarouselThumbnail.displayName = 'CarouselThumbnail'

export { CarouselThumbnail }
